import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const SampleInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Sample Section"
    sectionKey="Sample"
    backRoute="/sections/sample"
  />
);

export default SampleInternalTransfer;
